import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { LocationService } from '../services/location/location.service';
import { PAGE } from 'src/app/routes';

export const geoLocationGuard: CanActivateFn = async () => {
  const locationService = inject(LocationService);
  const router = inject(Router);

  // Don't worry about Locatation checking on web
  if (!Capacitor.isNativePlatform()) {
    return true;
  }

  // Don't worry about Locatation checking on android
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
    return true;
  }

  if (await locationService.isLocationChecked()) {
    if (await locationService.isLocationBlocked()) {
      router.navigate([PAGE.UNAVAILABLE]);
      return false;
    }
    return true;
  }

  router.navigate([PAGE.GEO_LOCATION_CHECK]);
  return false;
};
